/*
|-------------------------------------------------------------------------------
| routes.js
|-------------------------------------------------------------------------------
| Contains all of the routes for the application
*/

/*
    Imports Vue and VueRouter to extend with the routes.
*/
import {createRouter, createWebHistory} from 'vue-router'


/*
    Makes a new VueRouter that we will use to run all of the routes
    for the app.
*/
export default new createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/bill',
            name: 'layout',
            component: () => import("../components/layouts/layout"),
            children: [
                {
                    path: 'renew/:oauthClientId',
                    name: 'renewal',
                    component: () => import("../pages/TakeMoney.vue"),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'signup/:oauthClientId',
                    name: 'signup',
                    component: () => import("../pages/TakeMoney.vue"),
                    meta: { requiresAuth: false }
                }
            ]
        }
    ]
});
